import { jsx as _jsx } from "react/jsx-runtime";
import { PillTag } from '../../pill-tag';
export const TagsRenderer = (param)=>{
    let { value: tags } = param;
    if (!tags.length) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "flex h-full items-center gap-2 overflow-x-auto",
        children: tags.map((tag, index)=>/*#__PURE__*/ _jsx(PillTag, {
                label: tag,
                type: "success"
            }, index))
    });
};
